/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import Box from "@mui/material/Box";
import { useContext, useEffect, useState } from "react";
import uuid from "react-uuid";

import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";
import { Spinner } from "../../Common/Spinner";
import { UserContext } from "../../UserContext";
import { ClientCard } from "./ClientCard";

export const ClientSlideList = ({ locationId, triggerRefresh }) => {
	const debug = false;

	const [listUsers, setListUsers] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [noManagers, setNoManagers] = useState(false);

	const { selectedLocation } = useContext(UserContext);
	const { ApiCall } = useContext(ApiContext);

	const userRefresh = () => {
		ApiCall(
			"GET",
			`client/managers/${selectedLocation.id}`,
			null
		)
			.then((users) => {
				setListUsers(users);
				if (users.length === 0) setNoManagers(true);
			})
			.catch((error) => {
				if (debug) console.log(error);
				setIsLoading(false);
			});
	};

	useEffect(() => {
		setNoManagers(false);
		userRefresh();
	}, [selectedLocation, triggerRefresh]);

	useEffect(() => {
		if (noManagers || listUsers.length > 0) setIsLoading(false);
	}, [listUsers, noManagers]);

	return (
		<Box sx={{ height: "fit-content" }}>
			{isLoading ? (
				<Spinner color={ColorScheme.secondary}/>
			) : (
				listUsers.map((user) => (
					<ClientCard
						key={uuid()}
						manager={user}
						locationData={locationId}
						refresh={userRefresh}
					/>
				))
			)}
		</Box>
	);
};
